import React, { JSX, FC } from "react";
import InfoModal from "components/ui/modals/InfoModal/InfoModal";
import css from "./style.module.css";

interface IPropertiesListInfoModalProps {
  isOpen: boolean;
  onCancelHandler: () => void;
}

type StepType = {
  key: number;
  description: string;
}

const steps: StepType[] = [
  {
    key: 1,
    description: "Введите наименование свойства в поле ввода. Система запомнит его и добавит в список.",
  },
  {
    key: 2,
    description: "При постановке курсора в пустое поле «Свойства» система предложит выпадающий список свойств " +
      "товаров, которые Вы уже вводили.",
  },
  {
    key: 3,
    description: "Вы можете начать вводить свойство и система предложит список похожих свойств товаров, " +
      "которые Вы уже вводили.",
  },
  {
    key: 4,
    description: "Удалить свойство из персонального списка можно с помощью иконки «Корзина» справа от строки. " +
      "Если к этому свойству больше не привязан ни один товар, " +
      "то это свойство удалится из Вашего списка свойств.",
  },
  {
    key: 5,
    description: "Одинаковых свойств товаров создать и присвоить нельзя."
  }
];

const PropertiesListInfoModal: FC<IPropertiesListInfoModalProps> = ({
  isOpen,
  onCancelHandler,
}): JSX.Element => {
  const renderSteps = (): JSX.Element[] => steps.map(({ key, description }) => (
    <div key={key} className={`flex items-center gap-5 mb-2 ${css.wrap}`}>
      <span className="font-bold text-base">{key}</span>
      <p>{description}</p>
    </div>
  ));

  return (
    <InfoModal
      isOpen={isOpen}
      onClose={onCancelHandler}
      title="Как работает персональный список свойств товаров"
    >
      <>
        <p className="mb-5">
          В системе нет предустановленного списка свойств товаров.
          При введении наименований свойств в поле &quot;Свойства&quot;
          система формирует Ваш индивидуальный список свойств.
        </p>
        {renderSteps()}
      </>
    </InfoModal>
  );
};

export default PropertiesListInfoModal;
